import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { StreetNumberInput } from './StreetNumberInput';

export function StreetNumberField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return <GenericInputField<TValues> {...props} Input={StreetNumberInput} />;
}
